const store = {
	path: '/store',
	component: ()=>import("@/views/main.vue"),
	meta:{
		title:"门店管理后台",
		requiresAuth:false
	},
	children:[
		{
			path: 'Home',
			component: ()=>import("@/views/store/home.vue"),
			meta:{
				title:"首页",
				requiresAuth:false
			},
		},
		{
			path: 'User',
			component: ()=>import("@/views/store/user.vue"),
			meta:{
				title:"员工管理",
				requiresAuth:false
			},
		},
		{
			path: 'Role',
			component: ()=>import("@/views/store/role.vue"),
			meta:{
				title:"角色管理",
				requiresAuth:false
			},
		},
		{
			path: 'OrderDkzx',
			component: ()=>import("@/views/store/OrderDkzx.vue"),
			meta:{
				title:"订单信息",
				requiresAuth:false
			},
		},
		{
			path: 'Merchant',
			component: ()=>import("@/views/store/Merchant.vue"),
			meta:{
				title:"商户信息",
				requiresAuth:false
			},
		},
		{
			path: 'ShopList',
			component: ()=>import("@/views/store/shopList.vue"),
			meta:{
				title:"商品列表",
				requiresAuth:false
			},
		},
		
		{
			path: 'Store',
			component: ()=>import("@/views/store/Store.vue"),
			meta:{
				title:"门店信息",
				requiresAuth:false
			},
		},
		{
			path: 'ShopReport',
			component: ()=>import("@/views/store/ShopReport.vue"),
			meta:{
				title:"商品日报表",
				requiresAuth:false
			},
		},
		{
			path: 'dayReport',
			component: ()=>import("@/views/store/dayReport.vue"),
			meta:{
				title:"订单日报表",
				requiresAuth:false
			},
		},
		{
			path: 'PostWay',
			component: ()=>import("@/views/store/PostWay.vue"),
			meta:{
				title:"发货方式",
				requiresAuth:false
			},
		},
		{
			path: 'Addr',
			component: ()=>import("@/views/store/Addr.vue"),
			meta:{
				title:"地址管理",
				requiresAuth:false
			},
		},
		{
			path: 'ShareCode',
			component: ()=>import("@/views/store/ShareCode.vue"),
			meta:{
				title:"推广码",
				requiresAuth:false
			},
		},
		{
			path: 'Invoice',
			component: ()=>import("@/views/store/Invoice.vue"),
			meta:{
				title:"收货单管理",
				requiresAuth:false
			},
		},
		{
			path: 'Poster',
			component: ()=>import("@/views/store/Poster.vue"),
			meta:{
				title:"配送员管理",
				requiresAuth:false
			},
		},
		{
			path: 'warehouse',
			component: ()=>import("@/views/store/warehouse/Index.vue"),
			meta:{
				title:"仓库管理",
				requiresAuth:false
			},
			children:[
				{
					path: 'Item/:ware_id',
					component: ()=>import("@/views/store/warehouse/Item.vue"),
					meta:{
						title:"区域管理",
						requiresAuth:false
					},
				},
				{
					path: 'Branch/:ware_id',
					component: ()=>import("@/views/store/warehouse/Branch.vue"),
					meta:{
						title:"支线管理",
						requiresAuth:false
					},
				},
				{
					path: 'Tranfer/:ware_id',
					component: ()=>import("@/views/store/warehouse/Tranfer.vue"),
					meta:{
						title:"运输管理",
						requiresAuth:false
					},
				},
				{
					path: 'Invoice/:ware_id',
					component: ()=>import("@/views/store/warehouse/Invoice.vue"),
					meta:{
						title:"收货单管理",
						requiresAuth:false
					},
				},
				{
					path: 'Info/:ware_id',
					component: ()=>import("@/views/store/warehouse/Info.vue"),
					meta:{
						title:"仓库信息",
						requiresAuth:false
					},
				},
			]
		},
		{
			path: 'Ware',
			component: ()=>import("@/views/store/Ware.vue"),
			meta:{
				title:"仓库管理",
				requiresAuth:false
			},
		},
		{
			path: 'Seckill',
			component: ()=>import("@/views/store/Seckill.vue"),
			meta:{
				title:"秒杀活动",
				requiresAuth:false
			},
		},
		{
			path: 'SeckillOrder',
			component: ()=>import("@/views/store/SeckillOrder.vue"),
			meta:{
				title:"秒杀订单",
				requiresAuth:false
			},
		},
		{
			path: 'Goods',
			component: ()=>import("@/views/store/Goods.vue"),
			meta:{
				title:"商品管理",
				requiresAuth:false
			},
		},
		{
			path: 'PlatformGoods',
			component: ()=>import("@/views/store/PlatformGoods.vue"),
			meta:{
				title:"平台商品",
				requiresAuth:false
			},
		},
		{
			path: 'ShopCateg',
			component: ()=>import("@/views/store/ShopCateg.vue"),
			meta:{
				title:"商品类别",
				requiresAuth:false
			},
		},
		{
			path: 'ShopSizeStore',
			component: ()=>import("@/views/store/ShopSizeStore.vue"),
			meta:{
				title:"门店商品规格",
				requiresAuth:false
			},
		},
		{
			path: 'ShopAddNew/:good_id',
			component: ()=>import("@/views/store/ShopAddNew.vue"),
			meta:{
				title:"商品新增",
				requiresAuth:false
			},
		},

	]

}

export default store